export const styles = (theme) => ({
  title: {
    padding: "10px !important",
    textAlign: "center !important",
    "&.MuiDialogTitle-root": {
      fontWeight: "bold",
      textAlign: "center !important",
      padding: "0px !important",
    },
  },
  close: {
    paddingTop: "0.2rem",
    textAlign: "right",
    //width: '88%',
    [theme.breakpoints.down("sm")]: {
      //width: '82%'
    },
  },
  closeImg: {
    height: "1.2rem",
    width: "1.2rem",
    cursor: "pointer",
  },
  navGrid: {
    padding: "1rem 0rem 0rem 0.5rem",
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "1rem",
    },
  },
  back: {
    paddingLeft: "0.8rem",
  },
  actionBtn: {
    marginTop: "3rem",
    width: "15rem",
  },
  arrowLeft: {
    cursor: "pointer",
  },
  dialogContentRoot: {
    height: "0",
  },
  paperRoot: {
    [theme.breakpoints.down("sm")]: {
      height: "100%",
      width: "100%",
    },
  },
  alertRoot: {
    width: "500px",
    minHeight: "200px",
    paddingLeft: "28px",
  },
  alertContent: {
    paddingLeft: "0px",
    paddingRight: "18px",
  },
  alertAction: {
    justifyContent: "flex-end",
    margin: "0px 8px 8px 0px",
  },
  alertTitle: {
    paddingLeft: "0px",
  },
  alertTitleTextError: {
    color: "#ec7474",
  },
  formDialogRoot: {
    padding: "16px !important",
    marginTop: "16px !important",
  },
  confirmationContentSmall: {
    maxWidth: "320px",
    marginTop: "26px",
    padding: "16px",
  },
  confirmationActionWrapperSmall: {
    justifyContent: "flex-end",
  },
  confirmationActionButton: {
    width: "auto",
    minWidth: "unset !important",
  },
});

export default styles;
